import { create } from 'zustand'

export const useAppStore = create((set, get) => ({
  // Company switcher state
  activeCompany: '01', // Default to Adeptek
  setActiveCompany: (company) => {
    set({ activeCompany: company })
    sessionStorage.setItem('app_activeCompany', company)
  },

  // Sidebar state
  sidebarCollapsed: false,
  isSidebarExpanded: true,
  mobileSidebarOpen: false,
  toggleSidebar: () => set((state) => {
    const next = !state.sidebarCollapsed
    try { localStorage.setItem('app_sidebarCollapsed', next ? '1' : '0') } catch {}
    return { sidebarCollapsed: next, isSidebarExpanded: !next }
  }),
  setSidebarCollapsed: (collapsed) => {
    try { localStorage.setItem('app_sidebarCollapsed', collapsed ? '1' : '0') } catch {}
    set({ sidebarCollapsed: collapsed, isSidebarExpanded: !collapsed })
  },
  setIsSidebarExpanded: (expanded) => {
    try { localStorage.setItem('app_sidebarCollapsed', expanded ? '0' : '1') } catch {}
    set({ isSidebarExpanded: expanded, sidebarCollapsed: !expanded })
  },
  setMobileSidebarOpen: (open) => set({ mobileSidebarOpen: open }),

  // Theme (future: dark mode support)
  theme: 'light',
  setTheme: (theme) => {
    set({ theme })
    sessionStorage.setItem('app_theme', theme)
  },

  // Initialize from sessionStorage
  init: () => {
    try {
      const savedCompany = sessionStorage.getItem('app_activeCompany')
      const savedTheme = sessionStorage.getItem('app_theme')
      const savedCollapsed = localStorage.getItem('app_sidebarCollapsed') === '1'
      set({
        activeCompany: savedCompany || '01',
        theme: savedTheme || 'light',
        sidebarCollapsed: savedCollapsed,
        isSidebarExpanded: !savedCollapsed,
      })
    } catch (error) {
      console.error('Failed to restore app state:', error)
    }
  },

  // Get company label
  getCompanyLabel: (company) => {
    const companies = {
      '01': 'Adeptek',
      '02': 'Forte',
      'ALL': 'Tümü',
    }
    return companies[company] || company
  },

  // Sayfa filtre state'leri (navigate + reload edince kaybolmasın → sessionStorage'da kalıcı)
  pageFilters: (() => {
    try { return JSON.parse(sessionStorage.getItem('app_pageFilters') || '{}') } catch { return {} }
  })(),
  setPageFilter: (page, key, value) => set((state) => {
    const next = {
      ...state.pageFilters,
      [page]: { ...(state.pageFilters[page] || {}), [key]: value },
    }
    try { sessionStorage.setItem('app_pageFilters', JSON.stringify(next)) } catch {}
    return { pageFilters: next }
  }),
  getPageFilter: (page, key, fallback) => {
    return get().pageFilters[page]?.[key] ?? fallback
  },

  // Satışçı kodu → isim lookup (SALDEPT map)
  saldeptNames: {},          // { S12: 'İbrahim Günser', S13: 'Deniz ODALI', ... }
  // İsim haritası (async) yüklenince getSaldeptName referansını da YENİLE — böylece bu
  // fonksiyona abone olan bileşenler (teklif/satış/satınalma tabloları) yeniden render olup
  // kodu (S13) isimle (Deniz ODALI) günceller. Sabit referans kalırsa ilk boş haritayla
  // render eden tablolar bir daha güncellenmez → ham kod görünürdü.
  setSaldeptNames: (names) => set({
    saldeptNames: names,
    getSaldeptName: (code) => {
      if (!code) return '—'
      const c = (code || '').toString().trim().toUpperCase()
      const hit = names[code] || names[c]
      if (hit) return hit
      // Harita YÜKLÜ ve kod bir kişiye karşılık gelmiyorsa ham kod BASILMAZ
      // (CLAUDE.md: 'S99' gibi havuz kodları kullanıcıya gösterilmez). Harita
      // henüz gelmediyse kodu göster — aksi halde ilk render'da her satır '—' olur.
      return Object.keys(names).length ? '—' : c
    },
  }),
  getSaldeptName: (code) => {
    if (!code) return '—'
    const names = get().saldeptNames
    const c = (code || '').toString().trim().toUpperCase()
    const hit = names[code] || names[c]
    if (hit) return hit
    return Object.keys(names).length ? '—' : c
  },
}))
